import picNotFound from "../../../assets/projects/picNotFound.jpg";

import { IoRocketSharp, IoLogoGithub } from "react-icons/io5";
import { AiFillYoutube } from "react-icons/ai";
import { MdMore } from "react-icons/md";

import Modal from "../../Modal";

import "../../css/ProjectCard.css";

export default function ProjectCard({ project }: any) {

    return (
        <>
            <div className="card-project">
                <div className="icons-project">
                    {project.deploy &&
                        <a className="hovertext" data-hover="Visitar App" href={project.deploy} target="_blank" rel="noreferrer noopener">
                            <IoRocketSharp className="icon-project" />
                        </a>}
                    {project.repo &&
                        <a className="hovertext" data-hover="Repositorio" href={project.repo} target="_blank" rel="noreferrer noopener">
                            <IoLogoGithub className="icon-project" />
                        </a>}
                    {project.review &&
                        <a className="hovertext" data-hover="Review" href={project.review} target="_blank" rel="noreferrer noopener">
                            <AiFillYoutube className="icon-project" />
                        </a>}
                    {!project.deploy &&
                        !project.repo &&
                        !project.review &&
                        <p className="hovertext" data-hover="Privado"><IoLogoGithub className="icon-project icon-lock-project" /></p>
                    }
                    {project.more && <p onClick={project.modal.open} className="hovertext" data-hover="Más info"><MdMore className="icon-project" /></p>}
                </div>
                <div className="content-img-card">
                    <img className="img-card-project" src={project.pic ?? picNotFound} alt=""></img>
                    <p className="test gAnim">{project.type}</p>
                </div>
                <h1 className="title-card-project">{project.title}</h1>
                <p className="descript-card-project">{project.descriptionMini}</p>
                <div className="tech">
                    {project.techs?.map((tech: any, i: number) =>
                        <p key={i} className="title-tech">{tech}</p>
                    )}
                </div>
            </div>
            <Modal
                isOpen={project.modal.isOpen}
                closeModal={project.modal.close}
                title={project.title}
                descript={project.aditionalInfo}
                teamList={project.teamList}>
            </Modal>
        </>
    )
}